<script>
import { BFormTag } from "bootstrap-vue";

export default {
  extends: BFormTag
};
</script>